import React, { FC, useCallback, useMemo } from "react";
import { useWorkspaces } from "../../hooks/useWorkspaces";
import { useWorkspaceContext } from "../../state/workspaceContext";
import { Workspace } from "../../common/types/workspace";
import { Command } from "../../vendor/cmdk/cmdk";
import { useCommands } from "./useCommands";
import { WorkspaceCommandItem } from "./WorkspaceCommandItem";

export const WorkspacesCommandsList: FC = () => {
    const { close: closeCommands } = useCommands();
    const userWorkspaces = useWorkspaces({ withEntities: true });
    const { changeActiveWorkspace } = useWorkspaceContext();

    const handleSelected = useCallback(
        (workspace: Workspace) => {
            changeActiveWorkspace(workspace);
            closeCommands();
        },
        [changeActiveWorkspace, closeCommands],
    );

    const sortedWorkspaces = useMemo(
        () => userWorkspaces.data?.sort((a, b) => a.name.localeCompare(b.name)),
        [userWorkspaces.data],
    );

    return (
        <Command.Group heading="Workspaces">
            {sortedWorkspaces?.map((workspace, index) => (
                <WorkspaceCommandItem
                    key={workspace.id}
                    workspace={workspace}
                    index={index}
                    onSelected={() => handleSelected(workspace)}
                />
            ))}
        </Command.Group>
    );
};
